import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { 
    FaStore, FaUsers, FaSignOutAlt, FaCar, FaChartBar, 
    FaExclamationTriangle, FaShieldAlt, FaUserFriends,
    FaHome, FaBell, FaCog, FaChartLine, FaTimes, FaBars
} from 'react-icons/fa';

export default function AdminDashboard({ logout }) {
    const navigate = useNavigate();
    const [data, setData] = useState({ sucursales: [], total_garantia: 0 });
    const [alertas, setAlertas] = useState([]);
    const [activeBottomTab, setActiveBottomTab] = useState('home');
    const [showMobileMenu, setShowMobileMenu] = useState(false);
    const [currentTime, setCurrentTime] = useState(new Date());

    const fetchData = async () => {
        try {
            const res = await axios.get('https://api.alquilacarbolivia.com/api/dashboard');
            setData(res.data);
        } catch (error) { 
            console.error("Error cargando datos financieros:", error); 
        }
    };

    const fetchAlertas = async () => {
    try {
        const res = await axios.get('https://api.alquilacarbolivia.com/api/inventario/alertas-criticas');
        // Si la respuesta es un array, lo guardamos
        if (Array.isArray(res.data)) {
            setAlertas(res.data);
        }
    } catch (error) { 
        console.error("Error al conectar con el servicio de alertas:", error.message);
        setAlertas([]); // Limpiar alertas si falla
    }
};

    useEffect(() => {
        fetchData();
        fetchAlertas();
        const timer = setInterval(() => setCurrentTime(new Date()), 60000);
        return () => clearInterval(timer);
    }, []);

    const sucursalesMenu = [
        { 
            id: 1, 
            nombre: 'COMO EN CASA', 
            nombreCorto: 'Como en Casa',
            gradient: 'linear-gradient(135deg, #D31027 0%, #EA384D 100%)',
            color: '#D31027',
            icon: <FaStore />,
        },
        { 
            id: 2, 
            nombre: 'YUM YUM SUC. 1',
            nombreCorto: 'Yum Yum 1', 
            gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
            color: '#11998e',
            icon: <FaStore />,
        },
        { 
            id: 3, 
            nombre: 'YUM YUM SUC. 2',
            nombreCorto: 'Yum Yum 2', 
            gradient: 'linear-gradient(135deg, #f7971e 0%, #ffd200 100%)',
            color: '#f7971e',
            icon: <FaStore />,
        },
        { 
            id: 4, 
            nombre: 'ALQUILACAR',
            nombreCorto: 'Alquilacar', 
            gradient: 'linear-gradient(135deg, #f12711 0%, #f5af19 100%)',
            color: '#f12711',
            icon: <FaCar />,
        }
    ];

    const totalIngresos = data.sucursales.reduce((sum, s) => sum + parseFloat(s.total_vendido || 0), 0);

    // Bottom Navigation Items
    const bottomNavItems = [
        { id: 'home', icon: <FaHome />, label: 'Inicio' },
        { id: 'stats', icon: <FaChartLine />, label: 'Estadísticas' },
        { id: 'alerts', icon: <FaBell />, label: 'Alertas', badge: alertas.length },
        { id: 'more', icon: <FaCog />, label: 'Más' }
    ];

    return (
        <div style={{ 
            minHeight: '100vh',
            background: '#f8fafc',
            paddingBottom: '80px', // Espacio para bottom nav
            fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
            
            {/* ==================== MOBILE HEADER ==================== */}
            <div className="d-lg-none" style={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                boxShadow: '0 2px 12px rgba(0,0,0,0.1)'
            }}>
                <div className="d-flex align-items-center justify-content-between p-3">
                    <div className="d-flex align-items-center">
                        <div style={{
                            width: '40px',
                            height: '40px',
                            background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                            borderRadius: '10px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.2rem',
                            fontWeight: 'bold',
                            color: 'white',
                            marginRight: '12px'
                        }}>
                            CR
                        </div>
                        <div>
                            <div className="text-white fw-bold" style={{ fontSize: '1.1rem' }}>
                                Control-Rest
                            </div>
                            <small className="text-white-50" style={{ fontSize: '0.7rem' }}>
                                {currentTime.toLocaleDateString('es-BO', { day: 'numeric', month: 'short' })}
                            </small>
                        </div>
                    </div>
                    
                    <button 
                        className="btn btn-link text-white p-2"
                        onClick={() => setShowMobileMenu(!showMobileMenu)}
                        style={{ fontSize: '1.5rem' }}
                    >
                        {showMobileMenu ? <FaTimes /> : <FaBars />}
                    </button>
                </div>

                {/* Mobile Menu Dropdown */}
                {showMobileMenu && (
                    <div style={{
                        background: '#1e293b',
                        borderTop: '1px solid rgba(255,255,255,0.1)',
                        padding: '1rem'
                    }}>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/reportes'); setShowMobileMenu(false); }}
                        >
                            <FaChartBar className="me-2"/> Reportes
                        </button>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/usuarios'); setShowMobileMenu(false); }}
                        >
                            <FaUsers className="me-2"/> Usuarios
                        </button>
                        <button 
                            className="btn btn-outline-light btn-sm w-100 mb-2 text-start"
                            onClick={() => { navigate('/admin/clientes'); setShowMobileMenu(false); }}
                        >
                            <FaUserFriends className="me-2"/> Clientes
                        </button>
                        <button 
                            className="btn btn-danger btn-sm w-100 text-start"
                            onClick={logout}
                        >
                            <FaSignOutAlt className="me-2"/> Cerrar Sesión
                        </button>
                    </div>
                )}
            </div>

            {/* ==================== DESKTOP NAVBAR ==================== */}
            <nav className="navbar navbar-expand-lg navbar-dark shadow-lg d-none d-lg-flex" style={{ 
                background: 'linear-gradient(135deg, #1e293b 0%, #334155 100%)',
                borderBottom: '3px solid #f59e0b'
            }}>
                <div className="container-fluid px-4">
                    <div className="d-flex align-items-center">
                        <div className="me-3" style={{
                            width: '45px',
                            height: '45px',
                            background: 'linear-gradient(135deg, #f59e0b 0%, #f97316 100%)',
                            borderRadius: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            fontSize: '1.5rem',
                            fontWeight: 'bold',
                            color: 'white',
                            boxShadow: '0 4px 12px rgba(245, 158, 11, 0.3)'
                        }}>
                            CR
                        </div>
                        <div>
                            <div className="navbar-brand fw-bold mb-0" style={{ fontSize: '1.3rem' }}>
                                CONTROL-REST
                            </div>
                            <small className="text-white-50 d-block" style={{ marginTop: '-5px', fontSize: '0.7rem' }}>
                                Panel de Administración
                            </small>
                        </div>
                    </div>

                    <div className="d-flex align-items-center gap-2">
                        <div className="text-white-50 me-3" style={{ fontSize: '0.85rem' }}>
                            {currentTime.toLocaleDateString('es-BO', { weekday: 'short', day: 'numeric', month: 'short' })}
                        </div>

                        {alertas.length > 0 && (
                            <div className="position-relative me-2">
                                <FaBell className="text-warning" style={{ fontSize: '1.3rem' }}/>
                                <span className="position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger" style={{ fontSize: '0.6rem' }}>
                                    {alertas.length}
                                </span>
                            </div>
                        )}

                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/reportes')}>
                            <FaChartBar className="me-2"/> Reportes
                        </button>
                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/usuarios')}>
                            <FaUsers className="me-2"/> Usuarios
                        </button>
                        <button className="btn btn-outline-light btn-sm rounded-pill px-3" onClick={() => navigate('/admin/clientes')}>
                            <FaUserFriends className="me-2"/> Clientes
                        </button>
                        <button className="btn btn-danger btn-sm rounded-pill px-3" onClick={logout}>
                            <FaSignOutAlt className="me-1"/> Salir
                        </button>
                    </div>
                </div>
            </nav>

            {/* ==================== MAIN CONTENT ==================== */}
            <div className="container-fluid px-3 px-lg-4 py-3 py-lg-4">
                
                {/* ALERTAS CRÍTICAS */}
                {alertas.length > 0 && (
                    <div className="mb-3">
                        <div 
                            className="card border-0 shadow-sm" 
                            style={{ 
                                background: 'linear-gradient(135deg, #dc2626 0%, #ef4444 100%)',
                                borderRadius: '16px'
                            }}
                        >
                            <div className="card-body p-3">
                                <div className="d-flex align-items-center">
                                    <div 
                                        className="me-3 d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '45px',
                                            height: '45px',
                                            background: 'rgba(255, 255, 255, 0.2)',
                                            borderRadius: '12px',
                                            flexShrink: 0
                                        }}
                                    >
                                        <FaExclamationTriangle className="text-white" style={{ fontSize: '1.5rem' }} />
                                    </div>
                                    <div className="flex-grow-1 text-white">
                                        <div className="fw-bold mb-1" style={{ fontSize: '0.9rem' }}>
                                            Alerta de Inventario
                                        </div>
                                        <div style={{ fontSize: '0.8rem', opacity: 0.9 }}>
                                            {alertas.length} producto(s) con stock bajo
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* RESUMEN TOTAL */}
                <div className="card border-0 shadow-sm mb-3" style={{ borderRadius: '16px' }}>
                    <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-center">
                            <div>
                                <div className="text-muted small mb-1">Total de Ingresos Hoy</div>
                                <h3 className="fw-bold text-success mb-0">
                                    Bs {totalIngresos.toFixed(2)}
                                </h3>
                            </div>
                            <div 
                                style={{
                                    width: '50px',
                                    height: '50px',
                                    background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                                    borderRadius: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <FaChartLine className="text-white" style={{ fontSize: '1.5rem' }} />
                            </div>
                        </div>
                    </div>
                </div>

                {/* CARDS DE SUCURSALES - RESPONSIVE */}
                <div className="row g-3 mb-3">
                    {sucursalesMenu.map(suc => {
                        const montoData = data.sucursales.find(s => s.nombre === suc.nombre);
                        const monto = montoData ? montoData.total_vendido : 0;
                        const porcentaje = totalIngresos > 0 ? ((monto / totalIngresos) * 100).toFixed(1) : 0;
                        
                        return (
                            <div key={suc.id} className="col-12 col-sm-6 col-lg-3">
                                <div 
                                    className="card border-0 shadow-sm h-100" 
                                    style={{ 
                                        borderRadius: '16px',
                                        overflow: 'hidden',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onClick={() => suc.id === 4 ? navigate('/alquilacar') : navigate(`/sucursal/${suc.id}`)}
                                >
                                    {/* Barra de color */}
                                    <div style={{ height: '5px', background: suc.gradient }}></div>
                                    
                                    <div className="card-body p-3">
                                        {/* Header horizontal en móvil */}
                                        <div className="d-flex align-items-center justify-content-between mb-3">
                                            <div className="d-flex align-items-center flex-grow-1">
                                                <div 
                                                    className="me-2 d-flex align-items-center justify-content-center"
                                                    style={{
                                                        width: '40px',
                                                        height: '40px',
                                                        background: `${suc.color}15`,
                                                        borderRadius: '10px',
                                                        fontSize: '1.2rem',
                                                        color: suc.color,
                                                        flexShrink: 0
                                                    }}
                                                >
                                                    {suc.icon}
                                                </div>
                                                <div className="flex-grow-1 min-w-0">
                                                    <div 
                                                        className="fw-bold text-truncate" 
                                                        style={{ fontSize: '0.85rem', color: '#1e293b' }}
                                                    >
                                                        {suc.nombreCorto}
                                                    </div>
                                                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>
                                                        Hoy
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        
                                        {/* Monto */}
                                        <div className="mb-2">
                                            <h4 className="fw-bold mb-0" style={{ color: suc.color, fontSize: '1.5rem' }}>
                                                Bs {parseFloat(monto).toFixed(2)}
                                            </h4>
                                        </div>
                                        
                                        {/* Porcentaje */}
                                        <div className="d-flex justify-content-between align-items-center pt-2" style={{ borderTop: '1px solid #e5e7eb' }}>
                                            <span className="small text-muted">% del total</span>
                                            <span className="fw-bold" style={{ color: suc.color, fontSize: '0.9rem' }}>
                                                {porcentaje}%
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                {/* GARANTÍAS EN CUSTODIA */}
                <div className="row mb-3">
                    <div className="col-12 col-lg-8 mx-auto">
                        <div 
                            className="card border-0 shadow-sm" 
                            style={{ 
                                background: 'linear-gradient(135deg, #1e3a8a 0%, #3b82f6 100%)',
                                borderRadius: '16px'
                            }}
                        >
                            <div className="card-body p-3 p-lg-4">
                                <div className="row align-items-center">
                                    <div className="col-auto">
                                        <div 
                                            className="d-flex align-items-center justify-content-center"
                                            style={{
                                                width: '60px',
                                                height: '60px',
                                                background: 'rgba(255, 255, 255, 0.15)',
                                                borderRadius: '14px'
                                            }}
                                        >
                                            <FaShieldAlt className="text-white" style={{ fontSize: '2rem' }} />
                                        </div>
                                    </div>
                                    <div className="col text-white">
                                        <div className="small fw-bold mb-1 opacity-75">
                                            Garantías en Custodia
                                        </div>
                                        <h2 className="fw-bold mb-1" style={{ fontSize: 'clamp(1.5rem, 5vw, 2.5rem)' }}>
                                            Bs {parseFloat(data.total_garantia || 0).toFixed(2)}
                                        </h2>
                                        <div className="small opacity-75" style={{ fontSize: '0.8rem' }}>
                                            Depósitos de Alquilacar
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* ACCESOS RÁPIDOS (Solo Desktop) */}
                <div className="d-none d-lg-block">
                    <h5 className="fw-bold text-dark mb-3">Accesos Rápidos</h5>
                    <div className="row g-3">
                        {sucursalesMenu.map(suc => (
                            <div key={`quick-${suc.id}`} className="col-lg-3">
                                <div
                                    className="card border-0 shadow-sm h-100"
                                    style={{ 
                                        borderRadius: '16px',
                                        cursor: 'pointer',
                                        transition: 'all 0.3s'
                                    }}
                                    onClick={() => suc.id === 4 ? navigate('/alquilacar') : navigate(`/sucursal/${suc.id}`)}
                                    onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-5px)'}
                                    onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}
                                >
                                    <div style={{ height: '6px', background: suc.gradient, borderRadius: '16px 16px 0 0' }}></div>
                                    <div className="card-body text-center p-4">
                                        <div 
                                            className="mx-auto mb-3 d-inline-flex align-items-center justify-content-center"
                                            style={{
                                                width: '70px',
                                                height: '70px',
                                                background: `${suc.color}10`,
                                                borderRadius: '16px',
                                                fontSize: '2rem',
                                                color: suc.color
                                            }}
                                        >
                                            {suc.icon}
                                        </div>
                                        <h6 className="fw-bold mb-3">{suc.nombreCorto}</h6>
                                        <button 
                                            className="btn w-100 fw-bold rounded-pill py-2"
                                            style={{ 
                                                background: suc.gradient,
                                                color: 'white',
                                                border: 'none',
                                                fontSize: '0.85rem'
                                            }}
                                        >
                                            Administrar
                                        </button>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* ==================== BOTTOM NAVIGATION (Mobile Only) ==================== */}
            <div 
                className="d-lg-none"
                style={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    background: 'white',
                    borderTop: '1px solid #e5e7eb',
                    boxShadow: '0 -2px 10px rgba(0,0,0,0.05)',
                    zIndex: 1000,
                    paddingBottom: 'env(safe-area-inset-bottom)' // Para iPhones con notch
                }}
            >
                <div className="d-flex justify-content-around align-items-center" style={{ height: '65px' }}>
                    {bottomNavItems.map(item => (
                        <button
                            key={item.id}
                            className="btn border-0 position-relative d-flex flex-column align-items-center justify-content-center"
                            style={{
                                flex: 1,
                                height: '100%',
                                color: activeBottomTab === item.id ? '#3b82f6' : '#94a3b8',
                                background: 'transparent',
                                transition: 'all 0.2s'
                            }}
                            onClick={() => setActiveBottomTab(item.id)}
                        >
                            <div style={{ fontSize: '1.4rem', marginBottom: '2px' }}>
                                {item.icon}
                            </div>
                            <div style={{ fontSize: '0.65rem', fontWeight: '500' }}>
                                {item.label}
                            </div>
                            {item.badge > 0 && (
                                <span 
                                    className="position-absolute badge rounded-pill bg-danger"
                                    style={{ 
                                        top: '8px',
                                        right: '50%',
                                        transform: 'translateX(15px)',
                                        fontSize: '0.6rem',
                                        padding: '2px 5px'
                                    }}
                                >
                                    {item.badge}
                                </span>
                            )}
                        </button>
                    ))}
                </div>
            </div>

            {/* ESTILOS GLOBALES */}
            <style>{`
                /* Smooth scroll */
                html {
                    scroll-behavior: smooth;
                }

                /* Touch optimization */
                * {
                    -webkit-tap-highlight-color: transparent;
                }

                /* Card hover effects (desktop only) */
                @media (min-width: 992px) {
                    .card {
                        transition: transform 0.3s ease, box-shadow 0.3s ease;
                    }
                    .card:hover {
                        transform: translateY(-5px);
                        box-shadow: 0 12px 24px rgba(0,0,0,0.15) !important;
                    }
                }

                /* Prevent scroll when mobile menu is open */
                body.menu-open {
                    overflow: hidden;
                }

                /* Safe area for iPhone notch */
                @supports (padding: max(0px)) {
                    .container-fluid {
                        padding-left: max(12px, env(safe-area-inset-left));
                        padding-right: max(12px, env(safe-area-inset-right));
                    }
                }

                /* Responsive text */
                @media (max-width: 576px) {
                    h1 { font-size: 1.5rem !important; }
                    h2 { font-size: 1.3rem !important; }
                    h3 { font-size: 1.1rem !important; }
                }
            `}</style>
        </div>
    );
}
